export const NOTIFICATION_ACTION = {
  ACCEPT: "accept",
  REJECT: "reject",
};

export const NOTIFICATION_TYPE = {
  SHIFT_TRANSFER: "TRANSFER",
  SHIFT_SWAP: "SWAP",
  PROVIDER_SHIFT_ASSIGNMENT: "Provider shift assignment",
  FORECASTER_ASSIGNMENT_REQUEST: "forecaster notification",
  FORECASTER_SHIFT_ASSIGNMENT: "Forecaster shift assignment",
  SHIFT_ASSIGNMENT: "shift assignment",
};

export const NOTIFICATION_TITLE = {
  [NOTIFICATION_TYPE.SHIFT_SWAP]: "Swap Request",
  [NOTIFICATION_TYPE.SHIFT_TRANSFER]: "Transfer Request",
  [NOTIFICATION_TYPE.PROVIDER_SHIFT_ASSIGNMENT]:
    "Provider self assignment request",
  [NOTIFICATION_TYPE.FORECASTER_ASSIGNMENT_REQUEST]:
    "Forecaster assignment request",
  [NOTIFICATION_TYPE.FORECASTER_SHIFT_ASSIGNMENT]:
    "Forecaster shift assignment",
  [NOTIFICATION_TYPE.SHIFT_ASSIGNMENT]: "Shift assignment",
};

export const SHIFT_STATUS = {
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
};
